import { useMutation } from '@tanstack/react-query';
import { firstAccessIdentify } from '@/features/auth/services/invitation';
import type {
  FirstAccessIdentifyRequest,
  FirstAccessIdentifyResponse,
} from '@/features/auth/types/invitation.types';

interface UseFirstAccessIdentifyOptions {
  onSuccess?: (data: FirstAccessIdentifyResponse) => void;
  onError?: (error: Error) => void;
}

export function useFirstAccessIdentify(
  options?: UseFirstAccessIdentifyOptions
) {
  return useMutation<
    FirstAccessIdentifyResponse,
    Error,
    FirstAccessIdentifyRequest
  >({
    mutationFn: (payload) => firstAccessIdentify(payload),
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}
